import { render, staticRenderFns } from "./TaxFormModal.vue?vue&type=template&id=65232bc3&scoped=true&"
import script from "./TaxFormModal.vue?vue&type=script&lang=js&"
export * from "./TaxFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65232bc3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65232bc3')) {
      api.createRecord('65232bc3', component.options)
    } else {
      api.reload('65232bc3', component.options)
    }
    module.hot.accept("./TaxFormModal.vue?vue&type=template&id=65232bc3&scoped=true&", function () {
      api.rerender('65232bc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Finance/TaxFormModal.vue"
export default component.exports